import generalCodeMessages from "@/utils/responseMessages/generalCodeMessages"

export default {
	...generalCodeMessages
}
